import { Link } from "react-router-dom";
import { IDR, imgUrl } from "@/lib/api";

const PLACE = "https://images.unsplash.com/photo-1503341504253-dff4815485f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxibGFjayUyMHQtc2hpcnQlMjBzdHJlZXR3ZWFyJTIwbW9kZWx8ZW58MHx8fHwxNzg4MjQyNDEwfDA&ixlib=rb-4.1.0&q=85";

export default function ProductCard({ product }) {
  const img = imgUrl(product.front_image) || PLACE;
  const soldOut = product.status === "SOLD_OUT";
  const soon = product.status === "COMING_SOON";
  return (
    <Link to={`/product/${product.slug || product.id}`} data-testid={`product-card-${product.article_code}`} className="group block fade-in-up">
      <div className="relative overflow-hidden bg-[color:var(--surface)] aspect-[4/5]">
        <img src={img} alt={product.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500" />
        {product.new_drop && !soon && <span className="status-badge absolute top-2 left-2 bg-black">NEW DROP</span>}
        {soon && <span className="status-badge absolute top-2 left-2 bg-black">COMING SOON</span>}
        {soldOut && <span className="status-badge absolute top-2 left-2 bg-[color:var(--accent)] text-white border-transparent">SOLD OUT</span>}
      </div>
      <div className="mt-3 flex justify-between items-start gap-2">
        <div className="min-w-0">
          <div className="text-[10px] text-neutral-500 tracking-widest">{product.article_code}</div>
          <div className="display text-xl leading-tight truncate">{product.name}</div>
        </div>
        <div className="text-xs tabular-nums mt-1 whitespace-nowrap">{IDR(product.price)}</div>
      </div>
    </Link>
  );
}
